import {
  CMS,
  DXL,
  NEXT,
  WEBAPI_SERVERLESS,
  DXL_JOURNEY_APP,
  AWSAPI_CONSUMER,
  DXLCLOUD_CONSUMER,
  DXL_GATEWAY_CLOUD,
  FWV,
  WEBAPI_CEREBRO,
  ONBOARDING_V2,
  GENERIC_NO_CORS_CLIENT,
  VMS,
} from './config';
import { ClientOptions } from './model';

export const options: ClientOptions = {
  DXL,
  NEXT,
  CMS,
  WEBAPI_SERVERLESS,
  WEBAPI_CEREBRO,
  ONBOARDING_V2,
  DXL_JOURNEY_APP,
  AWSAPI_CONSUMER,
  DXLCLOUD_CONSUMER,
  DXL_GATEWAY_CLOUD,
  FWV,
  GENERIC_NO_CORS_CLIENT,
  VMS,
};
